import { AUTH_SIGNUP_URL } from '@ha/auth/common/routes';

import { defineRoute } from '../defineRoute';

export const DEFAULT_IS_USER_LANDLORD = 'false';
export const DEFAULT_SOURCE = '';
export const DEFAULT_PREV_URL = '';

export type SignupRouteParams = {
  isUserLandlord?: 'true' | 'false' | null;
  source?: string | null;
  prevUrl?: string | null;
};

export type SignupRouteParamsString = {
  isUserLandlord?: string;
  source?: string;
  prevUrl?: string;
};

export const Signup = defineRoute<SignupRouteParams, SignupRouteParamsString>({
  pathname: AUTH_SIGNUP_URL,
  options: { isLandlordRoute: false, isPublic: true },
  routeParamsStringifier: routeParams => {
    return {
      isUserLandlord: routeParams.isUserLandlord ?? undefined,
      source: routeParams.source ?? undefined,
      prevUrl: routeParams.prevUrl ?? undefined,
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      isUserLandlord:
        routeParamsString.isUserLandlord === 'true'
          ? routeParamsString.isUserLandlord
          : DEFAULT_IS_USER_LANDLORD,
      source: routeParamsString.source || DEFAULT_SOURCE,
      prevUrl: routeParamsString.prevUrl || DEFAULT_PREV_URL,
    };
  },
});
